import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { QuarterKey, Row } from 'components/EditableTable/types';

const initialState: {
  data: Row[];
  labels: QuarterKey[];
  chartsData: any;
  isDataReviewed: boolean;
  chartDataIdx: number;
  chartsDataSourceIdx: number;
  defaultQuarterIdx: number;
} = {
  data: [],
  labels: [],
  chartsData: [],
  chartDataIdx: 4,
  isDataReviewed: false,
  chartsDataSourceIdx: 0,
  defaultQuarterIdx: 0
};

const portCoDataSlice = createSlice({
  name: 'portCoData',
  initialState,
  reducers: {
    setPortCoData(state, action: PayloadAction<Row[]>) {
      state.data = action.payload;
    },
    setisDataReviewed(state, action: PayloadAction<boolean>) {
      state.isDataReviewed = action.payload;
    },
    setPortCoLabels(state, action: PayloadAction<QuarterKey[]>) {
      state.labels = action.payload;
    },
    setPortCoChartsData(state, action: PayloadAction<any[]>) {
      state.chartsData = action.payload;
    },
    setChartsDataSourceIdx(state, action: PayloadAction<number>) {
      state.chartsDataSourceIdx = action.payload;
    },
    setChartDataIdx(state, action: PayloadAction<number>) {
      state.chartDataIdx = action.payload;
    },
    setDefaultQuarterIdx(state, action: PayloadAction<number>) {
      state.defaultQuarterIdx = action.payload;
    }
  }
});

export const {
  setPortCoData,
  setPortCoLabels,
  setChartDataIdx,
  setisDataReviewed,
  setPortCoChartsData,
  setDefaultQuarterIdx,
  setChartsDataSourceIdx
} = portCoDataSlice.actions;

export default portCoDataSlice.reducer;
